export default {"src":"/_next/static/media/install-service-cart-icon.d2fc242a.svg","height":62,"width":62};